import { render, staticRenderFns } from "./addanimalAge.vue?vue&type=template&id=5f321e56"
import script from "./addanimalAge.vue?vue&type=script&lang=js"
export * from "./addanimalAge.vue?vue&type=script&lang=js"
import style0 from "./addanimalAge.vue?vue&type=style&index=0&id=5f321e56&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports